"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var attributes_1 = __importDefault(require("./attributes"));
var contact_1 = __importStar(require("./contact"));
var model_1 = __importDefault(require("./model"));
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link(props) {
        var _this = _super.call(this) || this;
        _this.description = '';
        _this.url = '';
        _this.initAttributes(props);
        return _this;
    }
    Link.attributes = {
        description: attributes_1.default.String({
            modelKey: 'description',
        }),
        url: attributes_1.default.String({
            modelKey: 'url',
        }),
    };
    return Link;
}(model_1.default));
var Name = /** @class */ (function (_super) {
    __extends(Name, _super);
    function Name(props) {
        var _this = _super.call(this) || this;
        _this.firstName = '';
        _this.lastName = '';
        _this.initAttributes(props);
        return _this;
    }
    Name.attributes = {
        firstName: attributes_1.default.String({
            modelKey: 'firstName',
            jsonKey: 'first_name',
        }),
        lastName: attributes_1.default.String({
            modelKey: 'lastName',
            jsonKey: 'last_name',
        }),
    };
    return Name;
}(model_1.default));
var NeuralSignatureContact = /** @class */ (function (_super) {
    __extends(NeuralSignatureContact, _super);
    function NeuralSignatureContact(props) {
        var _this = _super.call(this) || this;
        _this.initAttributes(props);
        return _this;
    }
    NeuralSignatureContact.prototype.toJSON = function () {
        return {
            job_titles: this.jobTitles,
            links: this.links,
            phone_numbers: this.phoneNumbers,
            emails: this.emails,
            names: this.names ? this.names.map(function (name) { return name.toJSON(); }) : this.names,
        };
    };
    NeuralSignatureContact.prototype.toContactObject = function (connection) {
        var contact = new contact_1.default(connection);
        if (this.names) {
            contact.givenName = this.names[0].firstName;
            contact.surname = this.names[0].lastName;
        }
        if (this.jobTitles) {
            contact.jobTitle = this.jobTitles[0];
        }
        if (this.emails) {
            var contactEmails_1 = [];
            this.emails.forEach(function (email) {
                return contactEmails_1.push(new contact_1.EmailAddress({ type: 'personal', email: email }));
            });
            contact.emailAddresses = contactEmails_1;
        }
        if (this.phoneNumbers) {
            var contactNumbers_1 = [];
            this.phoneNumbers.forEach(function (number) {
                return contactNumbers_1.push(new contact_1.PhoneNumber({ type: 'mobile', number: number }));
            });
            contact.phoneNumbers = contactNumbers_1;
        }
        if (this.links) {
            var webPages_1 = [];
            this.links.forEach(function (link) {
                if (link['url']) {
                    webPages_1.push(new contact_1.WebPage({ type: 'homepage', url: link['url'] }));
                }
            });
            contact.webPages = webPages_1;
        }
        return contact;
    };
    NeuralSignatureContact.attributes = {
        jobTitles: attributes_1.default.StringList({
            modelKey: 'jobTitles',
            jsonKey: 'job_titles',
        }),
        links: attributes_1.default.Collection({
            modelKey: 'links',
            itemClass: Link,
        }),
        phoneNumbers: attributes_1.default.StringList({
            modelKey: 'phoneNumbers',
            jsonKey: 'phone_numbers',
        }),
        emails: attributes_1.default.StringList({
            modelKey: 'emails',
        }),
        names: attributes_1.default.Collection({
            modelKey: 'names',
            itemClass: Name,
        }),
    };
    return NeuralSignatureContact;
}(model_1.default));
exports.default = NeuralSignatureContact;
